// Code review - Completed
// Documentation - Completed
import { useState, useEffect } from "react";
import { blockMasterHeader } from "../components/HeaderAttribute";
import MainLayout from "../components/MainLayout";
import InputText from "../ReusableComponents/InputText";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import BlockPopup from "../popup-containers/BlockPopup";
import MainPopup from "../popup-containers/MainPopup";
import toast from "react-hot-toast";
import {
  BindAPI,
  IUDAPI,
  LanguageTranslatorAPI,
} from "../services/APIConnection";
import GridPage from "../components/GridPage";
import PopUpButtons from "../components/PopUpButtons";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import Buttons from "../components/Buttons";
import AddScreenTitle from "../components/AddScreenTitle";
import { useLocation } from "react-router-dom";
import ErrorPopup from "../ReusableComponents/ErrorPopup";
import Loader from "../ReusableComponents/Loader";

import * as XLSX from "sheetjs-style";
import { useUserCapability } from "../components/ConstantReducerProvider";
const BlockMaster = () => {
  const location1 = useLocation();
  //All bind dropdown value and bind data value useState hooks handling.

  const { userProfileState } = useUserCapability();
  const [bindStateDropDown, setBindStateDropDown] = useState([]);
  const [bindBlockMasterDatas, setBindBlockMasterDatas] = useState([]);
  const [getDistrictDatas, setGetDistrictDatas] = useState([]);
  const [bindDistrict, setBindDistrict] = useState([]);
  const [bindDistrict1, setBindDistrict1] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  //All visible functionality useState hooks handling.
  const [viewDetails, setViewDetails] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [addScreenTitle, setAddScreenTitle] = useState(false);
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);

  // SDP Master insert and edit useState hooks handling .
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  const [stateError, setStateError] = useState("");

  const [district, setDistrict] = useState("");
  const [block, setBlock] = useState("");
  const [blockError, setBlockError] = useState("");

  const [districtError, setDistrictError] = useState("");
  const [mstBlockId, setMSTBlockId] = useState("");

  const createdBy = sessionStorage.getItem("createdBy");

  const [popUpDropDownData, setPopUpDropDownData] = useState({});
  const [blockMasterDatas, setBlockMasterData] = useState("");

  const [popUpOpen, setpopUpOpen] = useState(false);
  const [rowIndex, setRowIndex] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = (isOpen) => {
    setpopUpOpen(isOpen);
  };

  const showadd = () => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(true);
    setUpdateScreenTitle(false);
  };
  const blockExcelHeaders = [
    "S.No",
    "MstBlockId",
    "Country",
    "State",
    "District",
    "Block_en",
    "Block_ta",
    "Block_hi",
    "Block_mr",
    "Block_gu",

    "Block_kn",
    "Block_ml",


    "Block_te",
    "Block_bn",
    "Block_or",
    "Created By",
  ];


  const handleExport = async () => {
    try {
      const blockResponse = await BindAPI(
        "BlockAPI/BindBlockMasterExcel"
      );

      const userProfileDatas = userProfileState?.userProfile || [];
      const mstStateId = userProfileDatas[0]?.MstStateId;
      const orgStructureId = userProfileDatas[0]?.MstOrganizationId;

      let rows = []; // ✅ changed to let

      const tableData = blockResponse?.data?.Table || [];

      if (orgStructureId === 1) {
        rows = tableData;
        await IUDAPI(
          {
            mstUserId: parseInt(createdBy, 10),
            sp: "BLOCK MASTER",
            action: "EXCEL EXPORT",
            status: "SUCCESS",
            tableName: "mst_block",
            description: `Block Excel exported successfully. Total Records: ${rows.length}`,
          },
          "Log/IUDLog",
        );
        
      } else {
        rows = tableData.filter(
          (item) => item?.MstStateId === mstStateId
        );
        await IUDAPI(
          {
            mstUserId: parseInt(createdBy, 10),
            sp: "BLOCK MASTER",
            action: "EXCEL EXPORT",
            status: "SUCCESS",
            tableName: "mst_block",
            description: `Block Excel exported successfully. Total Records: ${rows.length}`,
          },
          "Log/IUDLog",
        );
      }
      if (rows.length === 0) {
        await IUDAPI(
          {
            mstUserId: parseInt(createdBy, 10),
            sp: "BLOCK MASTER",
            action: "EXCEL EXPORT",
            status: "FAILED",
            tableName: "mst_block",
            description: "No data available to export",
          },
          "Log/IUDLog",
        );
        toast.error("No data available to export", {
          duration: 1000,
          position: "top-center",
        });
        return;
      }

      // // ✅ pass only string headers
      // exportBlockData(
      //   blockExcelHeaders.map((col) => col.title),
      //   rows
      // );

      exportBlockData(blockExcelHeaders, rows);
    } catch (error) {
      console.error("Block Excel Export Error:", error);
      await IUDAPI(
              {
                mstUserId: parseInt(createdBy, 10),
                sp: "IUDLog",
                action: "Block Master EXPORT",
                status: "FAILED",
                tableName: "mst_block",
                description: error?.message || "Excel export failed",
              },
              "Log/IUDLog"
            );
      toast.error("Failed to export Block data", {
        duration: 1000,
        position: "top-center",
      });
    }
  };
  const exportBlockData = (columns, rows) => {
    /* ================= TITLE ================= */
    const titleRow = [
      {
        v: "Block Master",
        s: {
          font: { bold: true, sz: 16 },
          alignment: { horizontal: "left" },
        },
      },
    ];

    /* ================= HEADER ================= */
    const headerRow = columns.map((column) => ({
      v: column,
      s: {
        fill: { fgColor: { rgb: "2D2D6E" } },
        font: { bold: true, color: { rgb: "FFFFFF" } },
        alignment: { horizontal: "left" },
      },
    }));

    const spacingRow = [{ v: "" }];

    /* ================= DATA ROWS ================= */
    const dataRows = rows.map((row, index) => {
      const isAlt = index % 2 === 1;
      const style = isAlt ? { fill: { fgColor: { rgb: "F0F0F0" } } } : {};

      return [
        { v: index + 1, s: style },          // S.No
        { v: row.MstBlockId, s: style },
        { v: row.CountryName_en, s: style }, // Country
        { v: row.StateName_en, s: style },   // State
        { v: row.District_en, s: style },    // District
        { v: row.Block_en, s: style },       // Block
        { v: row.Block_ta, s: style },       // Block
        { v: row.Block_hi, s: style },       // Block
        { v: row.Block_mr, s: style },       // Block
        { v: row.Block_gu, s: style },       // Block

        { v: row.Block_kn, s: style },       // Block
        { v: row.Block_ml, s: style },       // Block


        { v: row.Block_te, s: style },       // Block
        { v: row.Block_bn, s: style },       // Block
        { v: row.Block_or, s: style },       // Block
        { v: row.CreatedByName, s: style },  // Created By
      ];
    });

    /* ================= SHEET DATA ================= */
    const wsData = [
      titleRow,
      spacingRow,
      headerRow,
      ...dataRows,
    ];

    const ws = XLSX.utils.aoa_to_sheet(wsData);

    /* ================= COLUMN WIDTH ================= */
    ws["!cols"] = [
      { width: 5 },   // S.No
      { width: 20 },  // Country
      { width: 20 },  // Country
      { width: 25 },  // State
      { width: 25 },  // District
      { width: 30 },  // Block
      { width: 30 },  // Block
      { width: 30 },  // Block
      { width: 30 },  // Block
      { width: 30 },  // Block
      { width: 30 },  // Block
      { width: 30 },  // Block
      { width: 30 },  // Block
      { width: 30 },  // Block
      { width: 30 },  // Block
      { width: 30 },  // Created By
    ];

    /* ================= ROW HEIGHT ================= */
    ws["!rows"] = [
      { hpt: 30 },
      { hpt: 15 },
      { hpt: 18 },
      ...Array(rows.length).fill({ hpt: 15 }),
    ];

    /* ================= BORDERS ================= */
    const applyStyles = (worksheet) => {
      const range = XLSX.utils.decode_range(worksheet["!ref"]);
      for (let R = range.s.r; R <= range.e.r; R++) {
        for (let C = range.s.c; C <= range.e.c; C++) {
          const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
          if (!worksheet[cellRef]) continue;

          worksheet[cellRef].s = {
            ...worksheet[cellRef].s,
            border: {
              top: { style: "thin", color: { rgb: "000000" } },
              bottom: { style: "thin", color: { rgb: "000000" } },
              left: { style: "thin", color: { rgb: "000000" } },
              right: { style: "thin", color: { rgb: "000000" } },
            },
          };
        }
      }
    };

    applyStyles(ws);

    /* ================= EXPORT ================= */
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Block Master");
    XLSX.writeFile(wb, "Block_Master.xlsx");

    toast.success("Excel exported successfully 👍", {
      duration: 1000,
      position: "top-center",
    });
  };

  const cancel = () => {
    setVisibleAdd(false);
    setVisibleTable(true);
    setpopUpOpen(false);
    setSubmitBtnDisabled(false);
    blockMasterData();
    setState("");
    setDistrict("");
    setDistrictError("");
    setStateError("");
    setBlock("");
    setBlockError("");
    setIsLoading(false);
  };

  // ✅ Reusable filter helper
  const filterBlocked = (data) =>
    (data || []).filter((item) => item.BlockedBy === null);

  useEffect(() => {
    blockMasterData();
  }, []);
  const blockMasterData = async () => {
    try {
      setIsLoading(true);

      // Run all APIs in parallel
      const [statesRes, blockRes, districtRes] = await Promise.all([
        BindAPI("StateAPI/GetState"),
        BindAPI("BlockAPI/BindBlockMaster"),
        BindAPI("IECAPI/BindDistrict"),
      ]);

      // ✅ States
      const statesData = filterBlocked(statesRes?.data?.Table).map((item) => ({
        value: item.MstStateId,
        label: item.StateName_en,
      }));
      setBindStateDropDown(statesData);

      // ✅ Blocks
      const userProfileDatas = userProfileState.userProfile;
      const mstStateId = userProfileDatas[0]?.MstStateId;
      const orgStructureId = userProfileDatas[0]?.MstOrganizationId;
      var filteredData = [];
      if (orgStructureId == 1) {

        filteredData = blockRes?.data?.Table;

      } else {

        filteredData = blockRes?.data?.Table?.filter(item =>
          item?.MstStateId === mstStateId
        );
      }

      setBindBlockMasterDatas(filteredData || []);

      // ✅ Districts
      setGetDistrictDatas(filterBlocked(districtRes?.data?.Table));
    } catch (error) {
      console.error("Error fetching dropdown data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleEdit = (rowIndex) => {
    setUpdateScreenTitle(true);
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(false);

    setState(bindBlockMasterDatas[rowIndex].MstStateId);
    setDistrict(bindBlockMasterDatas[rowIndex].MstDistrictId);
    setMSTBlockId(bindBlockMasterDatas[rowIndex].MstBlockId);
    setBlock(bindBlockMasterDatas[rowIndex].Block_en);
  };

  const handleBlock = (rowIndex, flag) => {
    handleOpen(true);
    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setBlockDetails(false);
      setUnBlockDetails(false);
      setRowIndex(rowIndex);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(true);
      setRowIndex(rowIndex);
      setUnBlockDetails(false);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);
      setRowIndex(rowIndex);
      setUnBlockDetails(true);
    }
    setBlockMasterData(bindBlockMasterDatas[rowIndex]);
    const BlockData = bindBlockMasterDatas[rowIndex];
    //State DropDown Value Start
    const stateDropDownValue = bindStateDropDown.find(
      (item) => item.value === BlockData.MstStateId
    );
    const editStateDropDownValue = {
      value: BlockData.MstStateId,
      label: stateDropDownValue ? stateDropDownValue.label : "Unknown",
    };
    //State DropDown Value End

    //District DropDown Value Start
    const DistrictDropDownValue = bindDistrict1.find(
      (item) => item.value === BlockData.MstDistrictId
    );
    const editDistrictDropDownValue = {
      value: BlockData.MstDistrictId,
      label: DistrictDropDownValue ? DistrictDropDownValue.label : "Unknown",
    };
    //District DropDown Value End

    const autoDropDownValues = [
      editStateDropDownValue,
      editDistrictDropDownValue,
    ];
    setPopUpDropDownData(autoDropDownValues);
  };

  const handleSubmit = async (items, flag) => {
    setSubmitBtnDisabled(true);
    setIsLoading(true);
    if (flag == 1 || flag == 2) {
      // validation start
      let stateValidate = "";
      let districtValidate = "";
      let blockValidate = "";

      blockValidate = block ? "" : "Enter Block";

      stateValidate = state ? "" : "Select a State";
      districtValidate = district ? "" : "Select a District";
      setBlockError(blockValidate);
      setStateError(stateValidate);
      setDistrictError(districtValidate);
      if (stateValidate && districtValidate && blockValidate) {
        setSubmitBtnDisabled(false);
      }
      // Validation end

      if (stateValidate || districtValidate || blockValidate) {
        setIsOpen(true);
      }

      if (!stateValidate && !districtValidate && !blockValidate) {
        setIsOpen(false);
        // const languageKeys = [
        //   "ta", // Tamil
        //   "hi", // Hindi
        //   "mr", // Marathi
        //   "gu", // Gujarati
        //   "kn", // Kannada
        //   "ml", // Malayalam
        //   "te", // Telugu
        //   "bn", // Bengali
        //   "or", // Oriya
        // ];
        // const translatedTexts = [];
        // for (let i of languageKeys) {
        //   const translateText = await LanguageTranslatorAPI(block, i);
        //   translatedTexts.push(
        //     translateText.data.data.translations[0].translatedText
        //   );
        // }
        const data = [
          {
            mstBlockId: mstBlockId ? mstBlockId : 0,
            mstCountryId: 1,
            mstStateId: state,
            mstDistrictId: district,
            block_en: block,
            block_ta: block,
            block_hi: block,
            block_mr: block,
            block_gu: block,
            block_kn: block,
            block_ml: block,
            block_te: block,
            block_bn: block,
            block_or: block,
            createdBy: createdBy,
            flag: flag,
          },
        ];
        const response = await IUDAPI(data, "BlockAPI/IUDBlock");
        if (flag == 1) {
          // Submit
          if (response.data.Table[0].Result === "S") {
            toast.success("Block data added successfully 👍", {
              duration: 5000,
              position: "top-center",
            });
            setTimeout(cancel, 5000);
          } else {
            toast.error("Failed to add Block data 👎", {
              duration: 2000,
              position: "top-center",
            });
            setTimeout(cancel, 2000);
          }
        } else if (flag == 2) {
          // Update
          if (response.data.Table[0].Result === "M") {
            toast.success("Block data updated successfully 👍", {
              duration: 5000,
              position: "top-center",
            });
            setTimeout(cancel, 5000);
          } else {
            toast.error("Failed to update Block data 👎", {
              duration: 2000,
              position: "top-center",
            });
            setTimeout(cancel, 2000);
          }
        }
      } else {
        setSubmitBtnDisabled(false);
        setIsLoading(false);
      }
    } else {
      const data = [
        {
          mstBlockId: bindBlockMasterDatas[items].MstBlockId,
          createdBy: createdBy,
          flag: flag,
        },
      ];
      const response = await IUDAPI(data, "BlockAPI/IUDBlock");
      if (flag == 3) {
        // Delete
        if (response.data.Table[0].Result === "D") {
          toast.success("Block data deleted successfully 👍", {
            duration: 5000,
            position: "top-center",
          });
          setTimeout(cancel, 5000);
        } else {
          toast.error("Failed to delete Block data 👎", {
            duration: 2000,
            position: "top-center",
          });
          setTimeout(cancel, 2000);
        }
      } else if (flag == 4) {
        // Block
        if (response.data.Table[0].Result === "B") {
          toast.success("Block data blocked successfully 👍", {
            duration: 5000,
            position: "top-center",
          });
          setTimeout(cancel, 5000);
        } else {
          toast.error("Failed to block Block data 👎", {
            duration: 2000,
            position: "top-center",
          });
          setTimeout(cancel, 2000);
        }
      } else if (flag == 5) {
        // Unblock
        if (response.data.Table[0].Result === "UB") {
          toast.success("Block data unblocked successfully 👍", {
            duration: 5000,
            position: "top-center",
          });
          setTimeout(cancel, 5000);
        } else {
          toast.error("Failed to unblock Block data 👎", {
            duration: 2000,
            position: "top-center",
          });
          setTimeout(cancel, 2000);
        }
      }
    }
  };
  useEffect(() => {
    if (location1.pathname == "/blockmaster") {
      setAddScreenTitle(false);
      setVisibleTable(true);
      setVisibleAdd(false);
    }
  }, [location1]);

  useEffect(() => {
    // Find the selected state in getLocationDatas
    const stateSelectedValue = getDistrictDatas.find(
      (item) => item.MstStateId == state // Replace with the desired MstStateId
    );
    setBindDistrict([]);
    if (stateSelectedValue) {
      const districtLabels = getDistrictDatas
        .filter((item) => item.MstStateId === stateSelectedValue.MstStateId)
        .map((item) => ({
          MstDistrictId: item.MstDistrictId,
          District_en: item.District_en,
        }));

      const districtSelected = districtLabels.map((LC) => ({
        value: LC.MstDistrictId, // Replace with the appropriate value
        label: LC.District_en,
      }));
      setBindDistrict(districtSelected);
    } else {
    }
  }, [state]);

  useEffect(() => {
    const dropDownDatas = async () => {
      try {
        const statesResponse = await BindAPI("IECAPI/BindDistrict");

        const DistrictData = statesResponse.data.Table.map((item) => ({
          value: item.MstDistrictId,
          label: item.District_en,
        }));

        setBindDistrict1(DistrictData);
      } catch (error) {
        // Handle API call errors (e.g., show an error message)
      }
    };

    dropDownDatas();
  }, []);

  return (
    <MainLayout pageName="2">
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />

      {visibleTable && (
        <GridPage
          title={"Block Master"}
          header={blockMasterHeader}
          records={bindBlockMasterDatas}
          handleEdit={handleEdit}
          handleAction={handleBlock}
          handleExportBtn={true}
          handleExport={handleExport}
          showAdd={showadd}
          blockView={true}
        />
      )}
      {visibleAdd && (
        <div class="w-full ">
          <div class="border-black">
            <AddScreenTitle
              addScreenTitle={addScreenTitle}
              updateScreenTitle={updateScreenTitle}
              title="Block Master"
            />
          </div>
          <div class="mx-auto md:w-2/5 w-full border-black">
            <div class="relative w-full h-full max-w-xl md:h-auto">
              <div class="relative bg-white rounded-lg shadow ">
                <div class="px-6 py-6 lg:px-8">
                  <form class="space-y-6" action="#">
                    <AutoDropDown
                      classStar="text-red-500"
                      classDiv="hidden"
                      title={"Country"}
                      options={[]}
                      selectedOption={country}
                      placeholder={"Select"}
                      name={"country"}
                      controlFunc={(value) => {
                        setCountry(value);
                      }}
                      Class="custom-class"
                      disabled="false"
                      tabIndex="1"
                    />
                    <AutoDropDown
                      classStar="text-red-500"
                      title="State"
                      options={bindStateDropDown}
                      placeholder="Select"
                      name="state"
                      selectedOption={bindStateDropDown.find(
                        (x) => x.value == state
                      )}
                      Class="custom-class"
                      tabIndex="1"
                      controlFunc={(value) => {
                        setDistrict("");
                        setState(value.value);
                        setStateError(value ? "" : "Select a State");
                      }}
                      controlFuncBlur={() => {
                        setStateError(state ? "" : "Select a State");
                      }}
                      errorMessage={stateError?.stateError}
                      setError={setStateError}
                    />

                    <AutoDropDown
                      classStar="text-red-500"
                      title="District"
                      options={bindDistrict}
                      placeholder="Select"
                      name="District"
                      selectedOption={
                        district
                          ? bindDistrict.find((x) => x.value == district)
                          : ""
                      }
                      Class="custom-class"
                      tabIndex="1"
                      controlFunc={(value) => {
                        setDistrict(value.value);
                        setDistrictError(value ? "" : "Select a District");
                      }}
                      controlFuncBlur={() => {
                        setDistrictError(district ? "" : "Select a District");
                      }}
                      errorMessage={districtError?.districtError}
                      setError={setDistrictError}
                    />

                    <InputText
                      classStar="text-red-500"
                      inputType={"text"}
                      title="Block"
                      name={"block"}
                      maxLength={100}
                      content={block}
                      controlFunc={(e) => {
                        // setBlock(e.target.value)
                        const value = e.target.value;
                        setBlock(value);
                        setBlockError(
                          value.length > 0
                            ? /^[\S]+(?:\s[\S]+)*$/.test(value)
                              ? "" // No error if the input is valid
                              : ""
                            : "Enter Block" // Error message if the input is empty
                        );
                      }}
                      controlFuncBlur={(e) => {
                        // setBlock(e.target.value);
                        // setBlockError(block.length > 0 ? "" : " Enter Block");
                        const trimmedValue = e.target.value.trim();
                        setBlock(trimmedValue);
                        setBlockError(
                          trimmedValue.length > 0
                            ? /^[\S]+(?:\s[\S]+)*$/.test(trimmedValue)
                              ? "" // No error if the input is valid
                              : "Only single spaces between words allowed"
                            : "Enter Block" // Error message if the input is empty
                        );
                      }}
                      errorMessage={blockError}
                    />
                  </form>
                  <Buttons
                    addScreenTitle={addScreenTitle}
                    updateScreenTitle={updateScreenTitle}
                    handleSubmit={handleSubmit}
                    cancel={cancel}
                    disabledBtn={submitBtnDisabled ? true : false}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}
      <MainPopup
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={handleBlock}
      >
        <div>
          <PopUpScreenTitle
            title="Block Master"
            setpopUpOpen={setpopUpOpen}
            viewDetails={viewDetails}
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
          />
          <BlockPopup data={blockMasterDatas} data2={popUpDropDownData} />
        </div>
        <PopUpButtons
          deleteDetails={deleteDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}
          rowIndex={rowIndex}
          handleSubmit={handleSubmit}
          cancel={cancel}
          disabledBtn={submitBtnDisabled ? true : false}
        />
      </MainPopup>
    </MainLayout>
  );
};

export default BlockMaster;
